import Image from 'next/image';
import styles from './Footer.module.css';

/** Footer statico con indirizzo, link social e loghi istituzionali. Componente server — nessun client state. */
export default function Footer() {
  return (
    <footer className={styles.footer} id='contact'>
      <div className={`container ${styles.footerContent}`}>
        <div>
          <strong>FAST Computing</strong>
          <p>SISSA – Scuola Internazionale Superiore di Studi Avanzati</p>
          <p>
            Via Bonomea 265 - 34136 Trieste, Italy -    <a href="mailto:info@fastcomputing.net">info@fastcomputing.net</a>
          </p>
        </div>
        <div className={styles.footerLinks}>
          <div className={styles.footerSocial}>
            <a href='https://www.linkedin.com/company/sissamathlab/mycompany/' target='_blank' rel='noopener noreferrer' aria-label='LinkedIn'>
              <Image src='/logo_linkedin.svg' alt='LinkedIn' width={22} height={22} />
            </a>
            <a href='https://github.com/mathLab' target='_blank' rel='noopener noreferrer' aria-label='GitHub'>
              <Image src='/logo_github.svg' alt='GitHub' width={22} height={22} />
            </a>
          </div>
          <div className={styles.footerLogos}>
            <a href='https://www.sissa.it/' target='_blank' rel='noopener noreferrer'>
              <Image src='/logo_only_sissa.png' alt='SISSA' width={44} height={44} />
            </a>
            <a href='https://mathlab.sissa.it/' target='_blank' rel='noopener noreferrer'>
              <Image src='/mathlab_logo.png' alt='MathLab' width={44} height={44} />
            </a>
            <a href='https://erc.europa.eu/homepage' target='_blank' rel='noopener noreferrer'>
              <Image src='/logo_ERC.png' alt='ERC' width={44} height={44} />
            </a>
            <a href='https://www.polotecnologicoaltoadriatico.it/business-unit/cluster-scienze-della-vita-fvg/' target='_blank' rel='noopener noreferrer'>
              <Image src='/cluster_s_v.png' alt='Cluster Scienze della vita' width={100} height={44} />
            </a>
            <a href='https://www.regione.fvg.it/rafvg/cms/RAFVG/ricerca/fare-ricerca/' target='_blank' rel='noopener noreferrer'>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'white', height: '44px', width: '100px' }}>
                <Image src='/fvg.png' alt='Cluster Scienze della vita' width={100} height={100} />
              </div>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
